import { useTranslation } from 'react-i18next';
import AuditDrawerFrame from 'components/admin/audit/AuditDrawerFrame';
import AuditTimeline from 'components/admin/audit/AuditTimeline';
import type { AdminAuditEvent } from 'api/adminAuditApi';
import { isRealignedTicket } from 'utils/auditLabels';
import RealignedTicketDetail from './RealignedTicketDetail';

interface EventDrawerProps {
  /** The row's own event, already loaded by the table — this drawer never fetches. */
  event: AdminAuditEvent | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Detail panel for ONE already-loaded event (J13): `AuditTimeline` in its own frame, or a realigned ticket's detail (8c). */
const EventDrawer = ({ event, open, onOpenChange }: EventDrawerProps) => {
  const { t } = useTranslation();
  if (!event) return null;
  if (isRealignedTicket(event)) {
    return <RealignedTicketDetail event={event} open={open} onOpenChange={onOpenChange} />;
  }

  return (
    <AuditDrawerFrame open={open} onOpenChange={onOpenChange} title={t('Details')} description={event.entityLabel ?? event.entityId}>
      <AuditTimeline events={[event]} retentionMonths={null} isLoading={false} isError={false} />
    </AuditDrawerFrame>
  );
};

export default EventDrawer;
